import { atom } from 'jotai';

import { Nullable } from 'v2/types';
import { FileModel } from 'v2/types/FileSystemModel';

export const selectedFileAtom = atom<Nullable<FileModel>>(null);
